module.exports = __webpack_public_path__ + "static/media/mobile_hero_rendering.11a39a02.jpg";